module.exports = {
  APPEND: "APPEND",
  PREPEND: "PREPEND"
};



// WEBPACK FOOTER //
// ./src/js/constants/SystemLogTypes.js